import React from "react";
import { Button, Typography } from "antd";
import Surface from "../layouts/Surface";

const { Text } = Typography;
const EmptyState = (props) => {
  const { onClick, icon, buttonText, text, disabled } = props;
  return (
    <Surface
      style={{
        padding: "127px 0 150px 0",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      {icon}
      {text ? <Text>{text}</Text> : null}
      <Button
        onClick={onClick}
        type="primary"
        style={{ marginTop: "34px" }}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </Surface>
  );
};

export default EmptyState;
